var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.$store.state.app.collapse
        ? "position-collapse-left"
        : "position-left",
      attrs: { id: "main-container" },
    },
    [
      _c(
        "div",
        { staticClass: "tab-container" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "tabs",
              class: _vm.$store.state.app.collapse
                ? "position-collapse-left"
                : "position-left",
              attrs: { closable: true, type: "card" },
              on: {
                "tab-click": _vm.selectedTabHandle,
                "tab-remove": _vm.removeTabHandle,
              },
              model: {
                value: _vm.mainTabsActiveName,
                callback: function ($$v) {
                  _vm.mainTabsActiveName = $$v
                },
                expression: "mainTabsActiveName",
              },
            },
            [
              _c(
                "el-dropdown",
                {
                  staticClass: "tabs-tools",
                  attrs: { "show-timeout": 0, trigger: "hover" },
                },
                [
                  _c(
                    "div",
                    { staticStyle: { "font-size": "20px", width: "50px" } },
                    [_c("i", { staticClass: "el-icon-arrow-down" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.tabsCloseCurrentHandle($event)
                            },
                          },
                        },
                        [_vm._v("Close current Tab")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.tabsCloseOtherHandle($event)
                            },
                          },
                        },
                        [_vm._v("Close other Tab")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.tabsCloseAllHandle($event)
                            },
                          },
                        },
                        [_vm._v("Close all Tab")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function ($event) {
                              return _vm.tabsRefreshCurrentHandle($event)
                            },
                          },
                        },
                        [_vm._v("Refresh current Tab")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.mainTabs, function (item) {
                return _c(
                  "el-tab-pane",
                  {
                    key: item.name,
                    attrs: { label: item.title, name: item.name },
                  },
                  [
                    _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                      _c("i", { class: item.icon }),
                      _vm._v(" " + _vm._s(_vm.$t(item.title)) + " "),
                    ]),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "keep-alive",
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [_c("router-view")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }